export default "__VITE_ASSET__aHgh03UB__"